import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { plainToClass } from 'class-transformer';

import { AccountManager } from 'app/shared/models/account-manager.model';

import { ClientReviewService } from './client-review.service';

@Component({
    templateUrl: './client-review.component.html',
    styleUrls: ['./client-review.component.css'],
    providers: [ClientReviewService]
})

/**
 * Component for displaying the client reviews.
 *
 * @author mukesh.kumara@vernuso.com (Mukesh Kumar)
 */
export class ClientReviewComponent implements OnInit {

    accountManagers: AccountManager[];
    showAndHide: boolean[];

    constructor(
        private clientReviewService: ClientReviewService
        , private router: Router
    ) { }

    ngOnInit() {
        this.clientReviewService.getAccountManagerInformation()
            .map(response => {
                return plainToClass(AccountManager, response.arrResult as Object[]);
            })
            .subscribe(
            success => {
                this.accountManagers = success;
                this.showAndHide = Array(this.accountManagers.length);
                for (let i = 0; i < this.showAndHide.length; i++) {
                    this.showAndHide[i] = false;
                }
            },
            err => {
                //TODO: Must open the snackbar.
            }
            );
    }

    toggleShowAndHide(index: number) {
        if (this.showAndHide[index]) {
            this.showAndHide[index] = false;
        } else {
            this.showAndHide[index] = true;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/clients/reviews/client-review.component.ts